<div class="relative flex flex-col w-full h-full">
    <div class="absolute top-0 right-0 pt-4 pr-4">
        <button mat-icon-button [matDialogClose]="false">
            <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start p-8 pb-6 sm:pb-8">
        <div
            class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600"
        >
            <mat-icon class="text-current" svgIcon="heroicons_outline:check"></mat-icon>
        </div>

        <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">
            <div class="text-xl leading-6 font-medium">{{ 'label_confirm_group_document_upload' | translate }}</div>
            <div class="flex flex-col text-secondary">
                <span><strong>{{ 'label_document_recipient_group' | translate }}:</strong> {{ data.groupName }}</span>
                @if (data.documentType === 'file') {
                <span><strong>{{ 'label_document_title' | translate }}:</strong> {{ data.fileName }}</span>
                } @if (data.documentType === 'template') {
                <span><strong>{{ 'label_template' | translate }}:</strong> {{ data.templateName }}</span>
                }
            </div>
        </div>
    </div>

    <div class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">
        <button mat-stroked-button [matDialogClose]="false">{{ 'label_cancel' | translate }}</button>
        <button color="primary" mat-flat-button [matDialogClose]="true">{{ 'label_confirm' | translate }}</button>
    </div>
</div>
